module.exports = __webpack_public_path__ + "static/one-req-many-res-6-4bfb73fd9f0d4cf09099f60ffb45e141.png";